import { useEffect, useState } from "react";
import { api } from "../lib/api";

// Simple module-level cache so every CRM page doesn't refetch /crm/meta.
let metaCache = null;
let metaInflight = null;

const FALLBACK_META = {
    lead_statuses: [],
    lead_sources: [],
    deal_stages: [],
    open_stages: [],
    quote_stage: "",
    activity_types: [],
    logged_types: ["Call", "Email", "Meeting", "Note"],
    activity_directions: ["Outbound", "Inbound"],
    call_outcomes: [],
    is_manager: false,
};

export function useCrmMeta() {
    const [meta, setMeta] = useState(metaCache || FALLBACK_META);
    const [loading, setLoading] = useState(!metaCache);

    useEffect(() => {
        let alive = true;

        if (metaCache) {
            setMeta(metaCache);
            setLoading(false);
            return () => {};
        }

        if (!metaInflight) {
            metaInflight = api
                .get("/crm/meta")
                .then((res) => {
                    metaCache = { ...FALLBACK_META, ...(res.data || {}) };
                    return metaCache;
                })
                .catch(() => {
                    metaInflight = null;
                    return FALLBACK_META;
                });
        }

        metaInflight.then((data) => {
            if (alive) {
                setMeta(data);
                setLoading(false);
            }
        });

        return () => {
            alive = false;
        };
    }, []);

    return { meta: meta || FALLBACK_META, loading };
}
